module.exports = __webpack_public_path__ + "img/outlander_safe.569c11a8.jpg";